export default __webpack_public_path__ + "static/media/themebel_big.11693980.svg";